/// <reference path="../../types/Enum.ts" />

namespace SPA
{
	export namespace Realtor
	{
		export class Page
			extends ui.tab.TabHTMLPresentation
		{
			private	m_Object: RealtorObjectModel;
			private Documents: DocumentManager;
			// private	m_LeftTab-:	Navigation;
			private m_Top: JQuery<HTMLElement>;
			private m_TabContent: JQuery[];

			private iwvWarningShown: boolean;
			private Events: Backbone.Events;

			private baufiRefreshInterval:number;
			private docsRefreshInterval:number;
			private exposeDocsRefreshInterval:number;

			public constructor( object: RealtorObjectModel)
			{
				super();

				this.m_Object		= object;
				this.Events = Backbone.Events;
				// this.m_LeftTab	= new Navigation();
				this.Documents = new DocumentManager();
				this.m_TabContent = [];
				this.iwvWarningShown = false;

				this.baufiRefreshInterval = 0;
				this.docsRefreshInterval = 0;
				this.exposeDocsRefreshInterval = 0;

				const idPrefix = 'object-' + (this.m_Object.Object ? this.m_Object.Object.ID : 0);

				this.requestDocuments();

				// Listen to organization changes
				this.Events.listenTo(app.getAuthenticationManager().Events, 'change:Employee', ()  => {
					$('#' + idPrefix + '-realtorseller').replaceWith(this.buildRealtorSeller());
				});

				const realtorTabs = $('<div role="navigation">')
					.append($('<ul class="nav nav-pills" class="object-nav" role="tablist">')
						.append(SPA.gui.Bootstrap.TabNav('#' + idPrefix + '-data', 'Objektdaten', true))
						.append(SPA.gui.Bootstrap.TabNav('#' + idPrefix + '-documents', 'Objekt-Dokumente'))
						.append(SPA.gui.Bootstrap.TabNav('#' + idPrefix + '-exposedocs', 'Exposé-Dokumente'))
						.append(SPA.gui.Bootstrap.TabNav('#' + idPrefix + '-expose', 'Exposédaten'))
						// .append(SPA.gui.Bootstrap.TabNav('#' + idPrefix + '-dates', 'Termine'))
						// .append(SPA.gui.Bootstrap.TabNav('#' + idPrefix + '-is24', 'ImmoScout24'))
						.append(SPA.gui.Bootstrap.TabNav('#' + idPrefix + '-finance-docs', 'Finanzierungs-Dokumente'))
						.append(SPA.gui.Bootstrap.TabNav('#' + idPrefix + '-finance-compare', 'Finanzierung'))
					);

				const dataTab = SPA.gui.Bootstrap.TabContent(idPrefix + '-data', '', true);
				this.m_TabContent = [
					dataTab,
					SPA.gui.Bootstrap.TabContent(idPrefix + '-documents', ''),
					SPA.gui.Bootstrap.TabContent(idPrefix + '-exposedocs', ''),
					SPA.gui.Bootstrap.TabContent(idPrefix + '-expose', ''),
					// SPA.gui.Bootstrap.TabContent(idPrefix + '-is24', ''),
					SPA.gui.Bootstrap.TabContent(idPrefix + '-finance-docs', ''),
					SPA.gui.Bootstrap.TabContent(idPrefix + '-finance-compare', '').addClass('finanzierung'),
				];

				const tabContent = realtorTabs.add(
					ui.$$.div().addClass('tab-content container-fluid')
						.append(this.m_TabContent)
					);

				this.buildDataTab(dataTab);

				const $topNav = tabContent;

				// SPA.Realtor.gui.BasicData.Build(this.m_Object).prependTo($topNav.find('#object-address-' + this.m_Object.Address.ID));

				const $advDataHtml = ui.$$.div().addClass('col-sm-12');

				// const energyCerts = new SPA.Realtor.EnergyCertificateBuilder(this.m_Object);
				// energyCerts.appendTo($objectDocuments);
				// energyCerts.rebuild($objectDocuments);

				if ( false && this.m_Object.Premise) {
					const premise = new SPA.Realtor.PremiseBuilder(this.m_Object.Premise);
					premise.appendTo($advDataHtml);
					premise.rebuild($advDataHtml);

					if (this.m_Object.Premise.Building !== undefined) {
						const modern = new SPA.Realtor.ModernizationBuilder(this.m_Object.Premise.Building[0]);
						modern.appendTo($advDataHtml);
						modern.rebuild($advDataHtml);

						const specials = new SPA.Realtor.SpecialsBuilder(this.m_Object.Premise);
						specials.appendTo($advDataHtml);
						specials.rebuild($advDataHtml);
					}
				}
				$advDataHtml.appendTo($topNav.find('#' + idPrefix + '-data'));

				$topNav.on('click', 'a[href^="#"]', (e) =>
				{
					e.preventDefault();

					$(e.currentTarget).tab('show');

					const request = e.currentTarget.href.split('-').pop();
					switch (request)
					{
						case 'documents':
							const images = this.buildDocumentTab();
							images.rebuild($('#' + idPrefix + '-documents'));

							clearInterval(this.docsRefreshInterval);
							this.docsRefreshInterval = setInterval(() =>
							{
								if ($topNav.find('#' + idPrefix + '-documents').hasClass("active")){
									images.refreshView();
									console.log( "docsRefreshInterval run..." );
								}
								else {
									clearInterval(this.docsRefreshInterval);
									console.log( "docsRefreshInterval cleared!" );
								}
							}, 10000);

							break;
						case 'exposedocs':
							// const exposedocs = new SPA.Realtor.BauFinanzierungBuilder(this.m_Object);
							const exposedocs = this.buildDocumentTab();
							exposedocs.rebuild($('#' + idPrefix + '-exposedocs'), undefined, true);

							clearInterval(this.exposeDocsRefreshInterval);
							this.exposeDocsRefreshInterval = setInterval(() =>
							{
								if ($topNav.find('#' + idPrefix + '-exposedocs').hasClass("active")){
									exposedocs.refreshView();
									console.log( "docsRefreshInterval run..." );
								}
								else {
									clearInterval(this.exposeDocsRefreshInterval);
									console.log( "exposeDocsRefreshInterval cleared!" );
								}
							}, 10000);

							break;
						case 'expose':
							const expose = new SPA.Realtor.ExposeBuilder(this.m_Object, this.Documents);
							expose.rebuild($('#' + idPrefix + '-expose'));
							break;
						case 'is24':
							const immo24 = new SPA.Realtor.IS24Builder(this.m_Object);
							immo24.rebuild($topNav.find('#' + idPrefix + '-is24'));
							// const is24 = new SPA.Realtor.Immo24Builder(this.m_Object, this.m_Images);
							// is24.rebuild($topNav.find('#' + idPrefix + '-is24'));
							break;
						case 'docs':
							const finance = new SPA.Realtor.FinanceBuilder(this.m_Object, this.Documents);
							finance.rebuild($topNav.find('#' + idPrefix + '-finance-docs'));
							break;
						case 'compare':
							const baufi = new SPA.Realtor.BauFinanzierungBuilder(this.m_Object);
							baufi.rebuild($topNav.find('#' + idPrefix + '-finance-compare'));

							// clearInterval(this.baufiRefreshInterval);
							// this.baufiRefreshInterval = setInterval(() =>
							// {
							// 	if ($topNav.find('#' + idPrefix + '-finance-compare').hasClass("active")){
							// 		baufi.rebuild($topNav.find('#' + idPrefix + '-finance-compare'));
							// 		console.log( "baufiRefreshInterval run..." );
							// 	}
							// 	else {
							// 		clearInterval(this.baufiRefreshInterval);
							// 		console.log( "cleared!" );
							// 	}
							// }, 2000);
							break;
					}
				});

				this.m_Top = $topNav;

				// ImmoWertV change watcher
				const vm = this;
				this.m_Top.on('change', '.iwv-req', () => {
					// Show a change warning ONCE per object upon change
					if (vm.iwvWarningShown || !vm.m_Object.ImmoWertV)
					{
						return;
					}
					this.iwvWarningShown = true;
					this.showIwvModalWarning();
				});

				this.Initialize({});
			}

			public rebuild( root?: ui.base.BaseHTMLElement|JQuery<HTMLElement> ): Page
			{
				if ( root ) { this.appendTo( root ); }

				this.empty();

				this.m_Top.appendTo(this.m_Root);

				// Chapter2 - no Left navigation anymore
				// this.m_LeftTab.clear();
				// this.m_LeftTab.addRegister( 'Objekt', new SPA.Realtor.ObjectBuilder( this.m_Object ), true );
				// this.m_LeftTab.addRegister( 'ImmoScout24', new SPA.Realtor.IS24Builder( this.m_Object ) );
				// this.m_LeftTab.addRegister('Expose erstellen', new SPA.Realtor.ExposeBuilder(this.m_Object));
				// this.m_LeftTab.rebuild( this );

				if ( this.m_Entry)
				{
					this.m_Entry.DeactivateReloadSpin();
				}

				return this;
			}

			public reload(): void
			{
				new Wollmilch.AJAX(
					{
						url: 'object/show/' + encodeURIComponent( btoa( this.m_Object.ObjectNumber ) ),
						method: 'GET',
						on:
						{
							success: ( text: string ) =>
							{
								let obj;

								try
								{
									obj = Wollmilch.jsonize( text );

									if ( !obj ) { throw new Error(); }
								}
								catch ( e )
								{
									return;
								}

								if ( obj.success && obj.data )
								{
									this.m_Object	= obj.data;

									this.rebuild();
								}
							}
						}
					},
					Wollmilch.AJAXCallbase_e.REALTOR
				).send();
			}

			private requestDocuments()
			{
				new Wollmilch.AJAX({
					url: 'document/list/' + btoa(this.m_Object.ObjectNumber),
					method: 'GET',
					on: {
						success: (text) => {
							const res = Wollmilch.jsonize(text);
							if (!res || res.success === false) {
								return;
							}

							this.Documents.setData(res.data);

							return true;
						}
					}
				}, AJAXCallbase_e.REALTOR).send();
			}

			private buildDataTab(root: JQuery<HTMLElement>): void
			{
				const printBtnTop = ui.$$.button()
					.addClass('btn btn-secondary btn-print btn-save-top')
					.on('click', (e) => {
						window.print();
					})
					.append($('<i class="fas fa-print"></i>  <span>Drucken</span>'));

				const submitBtnTop = ui.$$.button()
					.addClass('btn btn-success btn-save btn-save-top')
					.on('click', (e) => this.onSaveButtonClick(e))
					.append($('<i class="fas fa-save"></i> <span>Speichern</span>'));

				// const submitBtnBottom = ui.$$.button()
				// 	.addClass('btn btn-success btn-save btn-save-bottom')
				// 	.on('click', (e) => this.onSaveButtonClick(e));
				// 	.append($('<i class="fas fa-save"></i> <span>Speichern</span>'));

				// const bottomBtnDiv = ui.$$.div().addClass("row bottom-toolbar").append(submitBtnBottom);

				const btnDelete = ui.$$.button()
					.addClass('btn btn-default btn-delete-object')
					.attr({type: 'button'})
					.on('click', (e) => this.onDeleteButtonClick(e))
					.append($('<i class="fas fa-trash"></i> <span>Objekt löschen</span>'));
				root.empty().append(btnDelete);

				const bidderContacts = app.getContactManager().getItems(this.m_Object.ObjectNumber, 'bidder');
				const bidderView = new SPA.Realtor.BidderView({ObjectNumber: this.m_Object.ObjectNumber});

				const sellerContact = app.getContactManager().getItems(this.m_Object.ObjectNumber, 'seller');
				const ownerContact = app.getContactManager().getItems(this.m_Object.ObjectNumber, 'owner');

				const $dataTab = $(`<form class="col-lg-6 object-data">`)
					.append(
						printBtnTop,
						submitBtnTop,
						SPA.Realtor.gui.Address.Build(this.m_Object),
						SPA.Realtor.gui.BasicData.Build(this.m_Object)
						// submitBtnBottom
					)
					.add(ui.$$.div().addClass('col-lg-6')
						.append(
							this.buildRealtorSeller(),
							SPA.Realtor.gui.OwnerSeller.Build(ownerContact, sellerContact, this.m_Object.ObjectNumber),
							bidderView.render().el
						)
					);

				// const col = ui.$$.div().addClass('col-sm-12');
				// const realtor2 = new SPA.Realtor2.NewDisposalObject(app.getAuthenticationManager().getCompany(), this.m_Object.Data, 'view');
				// realtor2.rebuild(col);

				root.append($dataTab);
					// .append(col);
			}

			private buildRealtorSeller(): JQuery
			{
				return SPA.Realtor.gui.RealtorSeller.Build(this.m_Object);
			}

			private buildDocumentTab()
			{
				const images = new SPA.Realtor.AttachmentBuilder(this.m_Object, this.Documents);
				return images;
			}

			private onDeleteButtonClick(e)
			{
				e.preventDefault();

				// Request confirm for deletion
				const proceed = confirm('Möchten Sie dieses Dokument wirklich unwiderruflich löschen?');
				if (proceed === false) {
					return;
				}
				$(e.currentTarget).attr('disabled', 'disabled');

				app.getObjectManager().delete(this.m_Object.ObjectNumber, (done: boolean) => {
					if (done)
					{
						$('.object-' + this.m_Object.Object.ID).remove();
						app.getGlobalTabControl().removeTab(this.Entry());
					}
				});
			}

			// @todo correct type for e which accepts currentTarget property
			private onSaveButtonClick(e: any, intern?: boolean)
			{
				e.preventDefault();

				const requestData: { [key: string]: string|boolean } = {};
				const form: HTMLFormElement = $(e.currentTarget).closest('form').get(0);
				for (const item of form.elements)
				{
					if (item.name === '') {
						continue;
					}
					const $item = $(item);
					requestData.calc = this.iwvWarningShown;
					if ($item.hasClass('currency') || $item.hasClass('number')) {
						// Unformatted nice currency|number format, otherwise dots and comma causes headaches
						requestData[item.name] = accounting.unformat(item.value, ',').toString();
					} else {
						requestData[item.name] = item.value;
					}
				}

				app.getObjectManager().saveMoreData(this.m_Object.ObjectNumber, requestData, (data) => {
					if (data.iwv)
					{
						this.m_Object.ImmoWertV = data.iwv;
						const roundedIwv = accounting.formatMoney(Math.floor(data.iwv / 1000) * 1000);
						this.m_Top.find('input[name=immowert]').val(roundedIwv);
						// Reset Modal warning to pop up again
						this.iwvWarningShown = false;
					}

				});
			}

			private showIwvModalWarning()
			{
				const uiModal = new ui.dialog.Modal({
					size: 'lg',
					noCloseBtn: false,
					head: [$('<h3>ImmoWertV-Neuberechnung</h3>')],
					body: [
						$(`<div style='font-size:16px'></a><p>Sie möchten einen für die ImmoWertV-Berechnung relevanten Wert anpassen.<br>
Nach dem Speichern wird der aktuell eingetragene ImmoWertV automatisch neu berechnet und angezeigt.
<br><br>
(Hinweis auf Preisliste, falls Änderung kostenpflichtig wird.)</p></div>`)
					],
					foot: [
						$('<button class="btn btn-primary" data-dismiss="modal">Verstanden</button>')
					]
				});
				uiModal.Show();
			}
		}
	}
}
